import httpRequest from '@/api/request'
import {
  AssetChangeLogsData,
  RollappList_TransactionData,
  RollappTransactionData,
  RollappTxDetail_TransactionData,
  TransactionData,
  TransactionDetailData,
} from './interface'

/**
 * 交易列表
 * @param params
 * @returns
 */
export const getRestTxList = ({
  limit = 10,
  offset = 0,
  key,
}: {
  limit: number
  offset: number
  key?: string
}): Promise<TransactionData> => {
  return httpRequest.post('/api/txs/hub/list', { limit, offset, key })
}

/**
 * 交易详情
 * @param params
 * @returns
 */
export const getTransactionDetail = (
  hash: string,
): Promise<{ transaction: TransactionDetailData[] }> => {
  return httpRequest.get(`/api/tx/detail`, {
    params: {
      hash,
    },
  })
}

/**
 * 交易详情日志
 * @param params
 * @returns
 */
export const getTransactionRawLog = (
  hash: string,
): Promise<{ transaction: TransactionDetailData[] }> => {
  return httpRequest.get(`/api/rest/tx/raw_log`, {
    params: {
      hash,
    },
  })
}

/**
 * 签到详情
 * @param params
 * @returns
 */
export const getTransactionDetailMsgCheckIn = (
  hash: string,
): Promise<{ transaction: RollappTransactionData[] }> => {
  return httpRequest.get(`/api/checkin/tx/detail?hash=${hash}`)
}

/**
 * 签到详情日志
 * @param params
 * @returns
 */
export const getTransactionRawLogCheckIn = (
  hash: string,
): Promise<{ transaction: RollappTransactionData[] }> => {
  return httpRequest.get(`/api/rest/checkin/tx/raw_log`, {
    params: {
      hash,
    },
  })
}

/**
 * rollapp交易详情日志
 * @param params
 * @returns
 */
export const getTransactionRawLogRollapp = (
  hash: string,
): Promise<{ transaction: RollappTransactionData[] }> => {
  return httpRequest.get(`/api/rest/rollapp/tx/raw_log`, {
    params: {
      hash,
    },
  })
}

/**
 * 账户在交易前后资产变化
 * @param params
 * @returns
 */
export const getRestAccountAssetChangeLog = (params: {
  address: string
  tx_hash: string
}): Promise<AssetChangeLogsData> => {
  return httpRequest.get(`/api/rest/account/asset-change-log`, {
    params,
  })
}

/**
 * rollapp交易列表，支持分页查询
 * @param params
 * @returns
 */
export const getTxsRollappList = ({
  limit = 10,
  offset = 0,
  key,
}: {
  limit: number
  offset: number
  key?: string
}): Promise<RollappList_TransactionData> => {
  return httpRequest.post('/api/txs/rollapp/list', { limit, offset, key })
}

/**
 * rollapp交易详情
 * @param params
 * @returns
 */
export const getRollappTxDetail = (hash: string): Promise<RollappTxDetail_TransactionData> => {
  return httpRequest.get('/api/rest/rollapp/tx/detail', { params: { hash } })
}

/**
 * 查詢某屆競選的投票記錄
 * @param params
 * @returns
 */
export const getCommitteeElectionVoteInfo = ({
  limit = 10,
  offset = 0,
  election_id,
}: {
  limit: number
  offset: number
  election_id: number
}): Promise<RollappList_TransactionData> => {
  return httpRequest.get('/api/rest/committee/candidate_info', {
    params: { limit, offset, election_id },
  })
}
